import React from 'react'
import { withTranslation } from 'react-i18next'

const SlideShow = ({ t }) => {
  const collection = [
    { edition: 'JRMC-2020-1' },
    { edition: 'JRMC-2019-1' },
    { edition: 'JRMC-2013-1' },
    { edition: 'JRMC-2010-1' }
  ];
  return (
    <div className="uk-position-relative uk-visible-toggle" tabIndex="-1" data-autoplay data-autoplay-interval="4000" data-uk-slideshow="min-height: 450; max-height: 450; animation: slide">
      <ul className="uk-slideshow-items">
        {collection.map(item => <li key={item.edition} className="hero-slideshow-item"><img className="hero-slideshow-image" src={`collections/${item.edition}.jpg`} alt="hero-cover" /></li>)}
      </ul>
      <a className="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous data-uk-slideshow-item="previous"></a>
      <a className="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next data-uk-slideshow-item="next"></a>
    </div>
  )
}

function Index({ t }) {
  return (
    <>
      <div className="uk-child-width-expand@s" data-uk-grid>
        <div className="center-cildren-x-y">
          <div className="uk-grid-match">
              <div className="uk-card uk-card-default uk-border-rounded">
                <div className="uk-card-header">
                  <div className="uk-grid-small uk-flex-middle" data-uk-grid>
                    <div className="uk-width-expand">
                      <h1 className="brand-font">{t('magazine_title')}</h1>
                      <div><small>ISSN 2066-8996</small> ● <small>eISSN 2068-567X</small></div>
                      <small>{t('cavas_research_center')}</small>
                    </div>
                  </div>
                </div>
                {/* <div className="uk-card-header">
                  <div className="uk-grid-small uk-flex-middle" data-uk-grid>
                    <div className="uk-width-expand">
                      <small>{t('indexed-by')}</small>
                      <div>
                        <a href="https://journals.indexcopernicus.com/search/journal/issue?issueId=all&journalId=65753" target="_blank"><img width="220" src="/index/ici2.png" alt="ICI" /></a>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="uk-card-body">
                  <h4 className="brand-font">{t('pages.index.latest_release_authors')}</h4>
                  <span className="uk-label uk-label-success">1/2020</span>

                  <div className="uk-container">
                    <span className="uk-label uk-margin-small-right">Cristian Radu</span>
                    <span className="uk-label uk-margin-small-right">Dragoș Buhagiar</span>
                    <span className="uk-label uk-margin-small-right">George Banu</span>
                    <span className="uk-label uk-margin-small-right">Vasile Șirli</span>
                    <span className="uk-label uk-margin-small-right">Dan Bartha-Lazăr</span>
                    <span className="uk-label uk-margin-small-right">Andrada Cazan</span>
                    <span className="uk-label uk-margin-small-right">Eleni-Alexandra Popa</span>
                    <span className="uk-label uk-margin-small-right">Laurențiu Străuț</span>
                    <span className="uk-label uk-margin-small-right">Ondina Tăut</span>
                  </div>          
                </div>
              </div>
          </div>
        </div>
        <div className="uk-grid-match uk-width-1-3@m">
          <div className="uk-height-large uk-card uk-card-body uk-padding-remove uk-flex uk-flex-center uk-flex-middle">
            <SlideShow t={t} />
          </div>
        </div>
      </div>

      <div data-uk-grid className="uk-margin-remove-top">
        <div>
          <div className="uk-card uk-card-default uk-border-rounded">
            <div className="uk-card-body">
              <p className="uk-dropcap">{t('pages.index.description')}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="uk-container uk-margin-top">
        <div>
          <div className="uk-card uk-border-rounded">
            <div className="uk-card-body uk-padding-small uk-text-center">
              <p>{t('pages.index.partnership.part1')}</p>
              <h3>{t('pages.index.partnership.part2')}</h3>
              <span className="uk-label uk-margin-small-right">CAVAS</span>
              <p>{t('pages.index.partnership.part3')}</p>
              <h4 className="uk-margin-remove-bottom">{t('pages.index.partnership.part4')}</h4>
              <h4 className="uk-margin-remove-top uk-margin-remove-bottom">{t('pages.index.partnership.part5')}</h4>
              <h4 className="uk-margin-remove-top uk-margin-remove-bottom">{t('pages.index.partnership.part6')}</h4>
              <h4 className="uk-margin-remove-top uk-margin-remove-bottom">{t('pages.index.partnership.part7')}</h4>
              <p>{t('pages.index.partnership.part8')}</p>
              <h4 className="uk-margin-remove-top uk-margin-remove-bottom">{t('pages.index.partnership.part9')}</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(Index)
